module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_0.f3bfe77d.png";